<div class="dhl-form-field" fxFlex="0 0 100%">
  <div #formFieldWrapper class="dhl-form-field-wrapper">
    <div class="dhl-form-field__control" [ngClass]="{
        'dhl-form-field__control': true,
        '--set-border-error':
          (frmGroup.get($safeNavigationMigration(configData?.name))?.touched ||
            frmGroup.get($safeNavigationMigration(configData?.name))?.dirty) &&
          (frmGroup.get($safeNavigationMigration(configData?.name))?.invaild ||
            frmGroup.get($safeNavigationMigration(configData?.name))?.errors)
      }" [formGroup]="frmGroup">
      <label for="{{ configData?.name }}" [ngClass]="{
          'dhl-form-field__label': true,
          'dhl-label-error':
            (frmGroup.get($safeNavigationMigration(configData?.name))?.touched ||
              frmGroup.get($safeNavigationMigration(configData?.name))?.dirty) &&
            (frmGroup.get($safeNavigationMigration(configData?.name))?.invaild ||
              frmGroup.get($safeNavigationMigration(configData?.name))?.errors)
        }">{{ configData?.label }}
        <span *ngIf="configData?.required"> *</span>
      </label>
      <!-- removed [disabled] property -->
      <input autocomplete="off" id="{{ configData?.name }}" type="text"
        [formControlName]="$safeNavigationMigration(configData?.name)" [placeholder]="placeHolder" class="dhl-form-field__input"
        on-focus="onBlurSetActive($safeNavigationMigration($event?.target?.id), true)"
        (input)="validateInput($safeNavigationMigration($event?.target?.id), $safeNavigationMigration($event?.target?.value))"
        (focusout)="onBlurSetActive($safeNavigationMigration($event?.target?.id), false)" [required]="$safeNavigationMigration(configData?.required)" />

      <span (click)="clearInput()" *ngIf="
          frmGroup.get($safeNavigationMigration(configData?.name))?.value &&
          !frmGroup.get($safeNavigationMigration(configData?.name))?.errors
        ">
        <img class="dhl-input-copy-icon"  src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
        class="dhl-input-copy-icon">
          <g fill="none" fill-rule="evenodd">
              <g fill="#191919" fill-rule="nonzero">
                  <g>
                      <g>
                          <path d="M18.545 4L20 5.455 13.454 12 20 18.545 18.545 20 12 13.454 5.455 20 4 18.545 10.546 12 4 5.455 5.455 4 12 10.546 18.545 4z" transform="translate(-344 -2027) translate(80 967) translate(264 1060)"/>
                      </g>
                  </g>
              </g>
          </g>
      </svg> -->
      
      </span>
      <span (click)="clearInput()" *ngIf="
          frmGroup.get($safeNavigationMigration(configData?.name))?.value &&
          frmGroup.get($safeNavigationMigration(configData?.name))?.errors
        ">
        <img class="dhl-input-copy-icon"  src="../../../../../assets/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))" />
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" onclick="clearInput()"
          class="dhl-input-copy-icon">
          <g fill="none" fill-rule="evenodd">
            <g fill="#d0021b" fill-rule="nonzero">
              <g>
                <g>
                  <path
                    d="M18.545 4L20 5.455 13.454 12 20 18.545 18.545 20 12 13.454 5.455 20 4 18.545 10.546 12 4 5.455 5.455 4 12 10.546 18.545 4z"
                    transform="translate(-344 -2027) translate(80 967) translate(264 1060)" />
                </g>
              </g>
            </g>
          </g>
        </svg> -->
      </span>
    </div>

    <div *ngIf="configData?.hintText">
      <span class="dhl-input-hint">Optional hint text</span>
    </div>

    <div class="dhl-error-wrapper" *ngIf="
        (frmGroup.get($safeNavigationMigration(configData?.name))?.touched ||
          frmGroup.get($safeNavigationMigration(configData?.name))?.dirty) &&
        frmGroup.get(configData.name).errors
      ">
      <span class="dhl-error-icon">
        <!-- <img class="dhl-input-error-icon" src="../../../../../assets/icons/icons-cancel-circle.svg"> -->
        <img class="dhl-input-error-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,90,24,24))">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <g fill="none" fill-rule="evenodd">
            <g fill="#d0021b" fill-rule="nonzero">
              <g>
                <g>
                  <path
                    d="M20.305 8.482c-.491-1.105-1.105-2.046-1.923-2.864-.818-.818-1.76-1.432-2.864-1.923C14.414 3.205 13.268 3 12 3c-.818 0-1.636.123-2.414.327-.777.205-1.472.532-2.168.9-.654.41-1.268.86-1.8 1.391-.532.532-1.023 1.146-1.39 1.8-.41.655-.696 1.391-.9 2.168C3.122 10.364 3 11.141 3 12c0 .818.123 1.636.327 2.414.205.777.532 1.472.9 2.168.41.654.86 1.268 1.391 1.8.532.532 1.146 1.023 1.8 1.39.655.41 1.391.696 2.168.9.778.205 1.555.328 2.414.328.86 0 1.636-.123 2.414-.327.777-.205 1.472-.532 2.168-.9.654-.41 1.268-.86 1.8-1.391.532-.532 1.023-1.146 1.39-1.8.41-.655.696-1.391.9-2.168.205-.778.328-1.555.328-2.414 0-1.268-.205-2.414-.695-3.518zm-3.846 6.463l-1.268 1.269-3.068-3.069-3.068 3.069-1.269-1.269 3.069-3.068L7.786 8.81l1.269-1.268 3.068 3.068 3.068-3.068 1.268 1.268-3.068 3.068 3.068 3.068z"
                    transform="translate(-256 -2027) translate(80 967) translate(176 1060)" />
                </g>
              </g>
            </g>
          </g>
        </svg> -->
      </span>
      <div *ngIf="frmGroup.get(configData.name).errors.required">Required</div>
      <div *ngIf="frmGroup.get(configData.name).errors.maxLength">
        Exceeding maximum limit by
        {{ frmGroup.get(configData.name).errors.maxLength.exceedsChar }}
        {{ frmGroup.get(configData.name)?.errors?.maxLength.exceedsChar > 1 ? 'characters' : 'character' }}.
      </div>
      <div *ngIf="frmGroup.get(configData.name).errors.minLength">
        Minimum length requires 
          {{ frmGroup.get(configData.name)?.errors?.minLength.requiredChar }} 
          {{ frmGroup.get(configData.name)?.errors?.minLength.requiredChar > 1 ? 'more characters' : 'more character' }}.
      </div>
      <div *ngIf="
          frmGroup.get(configData.name).errors.pattern &&
          validationType === 'NoSpecialCharacter'
        ">
        Special character not allowed.
      </div>
      <div *ngIf="
          frmGroup.get(configData.name).errors.min ||
          (frmGroup.get(configData.name).errors.pattern &&
            validationType === 'Numeric')
        ">
        Only whole positive number allowed.
      </div>
      <div *ngIf="
          frmGroup.get(configData.name).errors.min ||
          (frmGroup.get(configData.name).errors.pattern &&
            validationType === 'Decimal')
        ">
        Only positive number allowed.
      </div>
      <div *ngIf="
          frmGroup.get(configData.name).errors.pattern &&
          validationType === 'DecimalWithMaxlength'
        ">
        Value should be less than 1000 and restricted to two decimals places.
      </div>
      <div *ngIf="frmGroup.get(configData.name).errors.unAvailable">
        {{ frmGroup.get(configData.name).errors.unAvailable.message }}
      </div>
      <div *ngIf="
          frmGroup.get(configData.name).errors.pattern &&
          validationType === 'Email'
        ">
        Invalid E-Mail not allowed.
      </div>
    </div>
  </div>
</div>